module.exports = __webpack_public_path__ + "img/@service_img_02.7de3ec5f.jpg";